// Legacy type form an old survey question
export enum RunPayrollValues {
  YES = 'yes',
  NO = 'no',
}

export enum SurveyQuestionsKeys {
  INDUSTRY_IDENTIFICATION = 'INDUSTRY_IDENTIFICATION',
  INTENT_STEP = 'INTENT_STEP',
  NUMBER_EMPLOYEES_SEGMENTATION = 'NUMBER_EMPLOYEES_SEGMENTATION',
  NUMBER_STATES = 'NUMBER_STATES',
  PREV_PAYROLL_PROVIDER = 'PREV_PAYROLL_PROVIDER',
  WHAT_TO_USE = 'WHAT_TO_USE',
  WHO_TO_PAY = 'WHO_TO_PAY',
  RUN_PAYROLL = 'RUN_PAYROLL', // Legacy key
}

export { default as IndustryIdentification } from 'packages/signup/components/SurveyQuestions/IndustryIdentification';
export * from 'packages/signup/components/SurveyQuestions/IndustryIdentification';

export { default as Intent } from 'packages/signup/components/SurveyQuestions/Intent';
export * from 'packages/signup/components/SurveyQuestions/Intent';

export { default as NumberEmployeesSegmentation } from 'packages/signup/components/SurveyQuestions/NumberEmployeesSegmentation';
export * from 'packages/signup/components/SurveyQuestions/NumberEmployeesSegmentation';

export { default as NumberStates } from 'packages/signup/components/SurveyQuestions/NumberStates';
export * from 'packages/signup/components/SurveyQuestions/NumberStates';

export { default as PreviousPayrollProvider } from 'packages/signup/components/SurveyQuestions/PreviousPayrollProvider';
export * from 'packages/signup/components/SurveyQuestions/PreviousPayrollProvider';

export { default as WhatToUse } from 'packages/signup/components/SurveyQuestions/WhatToUse';
export * from 'packages/signup/components/SurveyQuestions/WhatToUse';

export { default as WhoToPay } from 'packages/signup/components/SurveyQuestions/WhoToPay';
export * from 'packages/signup/components/SurveyQuestions/WhoToPay';
